export default __webpack_public_path__ + "static/media/hirilun_letras.9941f865.png";